import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../../components/ui/dialog';
import { Package, Hash } from 'lucide-react';

export function ReceivingHistoryDialog({ open, onOpenChange, product, history, loading }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-zinc-900 border-zinc-800 max-w-3xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <Package className="h-5 w-5 text-[#78BE20]" />
            Receiving History — {product?.name}
          </DialogTitle>
        </DialogHeader>
        <div className="mt-2">
          <div className="flex items-center gap-4 mb-4 text-sm">
            <span className="text-zinc-500">SKU: <span className="text-white font-mono">{product?.sku}</span></span>
            <span className="text-zinc-500">Current Stock: <span className="text-white font-bold">{product?.stock_qty}</span></span>
            {product?.track_serials && (
              <span className="text-xs bg-[#78BE20]/20 text-[#78BE20] px-2 py-0.5 rounded flex items-center gap-1">
                <Hash className="h-3 w-3" /> Serial Tracked
              </span>
            )}
          </div>

          {loading ? (
            <div className="text-zinc-400 py-8 text-center">Loading history...</div>
          ) : history.length === 0 ? (
            <div className="text-zinc-500 py-8 text-center bg-zinc-800/50 rounded-lg">
              <Package className="h-8 w-8 mx-auto mb-2 text-zinc-600" />
              <p>No receiving history found for this product.</p>
              <p className="text-xs text-zinc-600 mt-1">Stock received via purchase orders will appear here.</p>
            </div>
          ) : (
            <div className="space-y-3">
              {history.map((record, idx) => (
                <div key={idx} className="bg-zinc-800 rounded-lg overflow-hidden" data-testid={`history-record-${idx}`}>
                  <div className="p-3 flex items-center justify-between">
                    <div className="flex items-center gap-4">
                      <div>
                        <p className="text-white text-sm font-medium">
                          {record.po_number || 'Unknown PO'}
                        </p>
                        {record.supplier_name && (
                          <p className="text-zinc-500 text-xs">{record.supplier_name}</p>
                        )}
                      </div>
                    </div>
                    <div className="flex items-center gap-4 text-sm">
                      <div className="text-right">
                        <p className="text-white font-bold">+{record.quantity_received}</p>
                        <p className="text-zinc-500 text-xs">units</p>
                      </div>
                      {record.cost_price != null && (
                        <div className="text-right">
                          <p className="text-zinc-300 font-mono">${Number(record.cost_price).toFixed(2)}</p>
                          <p className="text-zinc-500 text-xs">cost/unit</p>
                        </div>
                      )}
                      <div className="text-right min-w-[100px]">
                        <p className="text-zinc-300 text-xs">
                          {record.received_at ? new Date(record.received_at).toLocaleDateString('en-AU', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}
                        </p>
                        <p className="text-zinc-600 text-xs">
                          {record.received_at ? new Date(record.received_at).toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit' }) : ''}
                        </p>
                      </div>
                    </div>
                  </div>
                  {record.serial_numbers?.length > 0 && (
                    <div className="border-t border-zinc-700 px-3 py-2 bg-zinc-800/50">
                      <p className="text-[10px] uppercase text-zinc-500 mb-1.5 flex items-center gap-1">
                        <Hash className="h-3 w-3" /> Serial Numbers ({record.serial_numbers.length})
                      </p>
                      <div className="flex flex-wrap gap-1.5">
                        {record.serial_numbers.map((sn, si) => (
                          <span key={si} className="text-xs bg-zinc-900 text-white font-mono px-2 py-0.5 rounded">
                            {sn}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                  {record.notes && (
                    <div className="border-t border-zinc-700 px-3 py-2">
                      <p className="text-zinc-500 text-xs">{record.notes}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
